var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import TextField from "@bryntum/core-thin/lib/widget/TextField.js";
class FilterField extends TextField {
  static get configurable() {
    return {
      /**
       * The model field name to filter by. Can optionally be replaced by {@link #config-filterFunction}
       * @config {String}
       * @category Filtering
       */
      field: null,
      /**
       * The store to filter.
       * @config {Core.data.Store}
       * @category Filtering
       */
      store: null,
      /**
       * Optional filter function to be called with record and value as parameters for store filtering.
       * ```javascript
       * {
       *     type           : 'filterfield',
       *     store          : myStore,
       *     filterFunction : (record, value)  => {
       *        return record.text.includes(value);
       *     }
       * }
       * ```
       *
       * @config {Function}
       * @param {Core.data.Model} record Record for comparison
       * @param {String} value Value to compare with
       * @returns {Boolean} Returns `true` if record matches comparison requirements
       *
       * @category Filtering
       */
      filterFunction: null,
      clearable: true,
      revertOnEscape: true,
      ignoreParentReadOnly: true,
      keyStrokeChangeDelay: 100,
      internalListeners: {
        change: "onInternalChange"
      }
    };
  }
  updateValue(value, old) {
    super.updateValue(value, old);
    if (value && this.isConfiguring) {
      this.onInternalChange({ value });
    }
  }
  onInternalChange({ value }) {
    const { store, field, filterFunction } = this;
    if (store) {
      const filterId = `${field || this.id}-Filter`;
      if (value.length === 0) {
        store.removeFilter(filterId);
      } else {
        let filterBy;
        if (filterFunction) {
          filterBy = (record) => filterFunction(record, value);
        } else {
          value = value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          filterBy = (record) => {
            var _a;
            return (_a = record.getValue(field)) == null ? void 0 : _a.match(new RegExp(value, "i"));
          };
        }
        store.filter({
          id: filterId,
          filterBy
        });
      }
    }
  }
}
__publicField(FilterField, "$name", "FilterField");
__publicField(FilterField, "type", "filterfield");
;
FilterField.initClass();
FilterField._$name = "FilterField";
export {
  FilterField as default
};
